import { x25519 } from '@noble/curves/ed25519';
import { uploadBlob } from '../api/blobUpload';
import { api } from '../api/client';
import { uploadFolderShareLabel } from './shareLabelUpload';
import {
  createEmptyManifest,
  encryptFolderManifest,
} from './sharedFolderManifest';
import {
  encodeBase64,
  randomBytes,
} from './primitives';
import { loadVaultSession } from './vaultSession';
import { wrapKey } from './wrappedKey';

export async function createEmptySharedFolder(
  expiresAt: Date,
  label?: string,
): Promise<{
  id: string;
  serverToken: string;
  folderKey: Uint8Array;
}> {
  const session = loadVaultSession();
  if (!session) {
    throw new Error('vault_locked');
  }

  const folderKey = randomBytes(32);
  const manifestPlain = createEmptyManifest();
  const manifestBlob = await encryptFolderManifest(folderKey, manifestPlain);
  const manifestBlobId = await uploadBlob(manifestBlob);

  const userPublicKey = x25519.getPublicKey(session.userPrivateKey);
  const wrappedFolderKey = await wrapKey(
    folderKey,
    userPublicKey,
    'shareweb:folder:create',
  );

  const created = await api.createSharedFolder({
    manifestBlobId,
    wrappedFolderKey: encodeBase64(wrappedFolderKey),
    expiresAt: expiresAt.toISOString(),
  });

  if (label?.trim()) {
    const labelBlobId = await uploadFolderShareLabel(folderKey, label);
    await api.patchSharedFolder(created.id, { labelBlobId });
  }

  return { id: created.id, serverToken: created.serverToken, folderKey };
}
